import moment from 'moment-timezone'

export const timezoneMap = {
  CST: 'CT',
  CDT: 'CT',
  EST: 'ET',
  EDT: 'ET',
  MST: 'MT',
  MDT: 'MT',
  PST: 'PT',
  PDT: 'PT'
}

export function useDeliveryTimeZone(delivery) {
  const cutoffTime = delivery?.cutoff.time
  const userTimeZone = delivery?.cutoff.userTimeZone || ''

  const timezoneAbbreviation = moment.tz(cutoffTime, userTimeZone).format('z')

  return timezoneMap[timezoneAbbreviation] || ''
}

export function fromDaylightTzToStandardTzLabel(timezoneAbbreviation: string) {
  return timezoneMap[timezoneAbbreviation] ?? ''
}
